import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import Crosses from "./Crosses";
import { useNavigate } from "react-router-dom";

function UpdateCrosses() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Installation Details">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Update pole Cross</h4>

          <Crosses navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdateCrosses;
